import * as Yup from 'yup'

export default Yup.object().shape({
  company: Yup.string()
  .required('screens.createMaintenance.required'),
  userID: Yup.string()
  .required('screens.createMaintenance.required'),
  mileage: Yup.string()
  .required('screens.createMaintenance.required'),
  title: Yup.string()
  .required('screens.createMaintenance.required'),
  description: Yup.string()
  .required('screens.createMaintenance.required')
})